var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kpi-item kpi-item--warning" }, [
    _c("div", { staticClass: "kpi-item__illustration" }, [
      _c("img", {
        attrs: {
          src: "/ressources/logged/img/illustrations/kpis/empty-params.svg",
          alt: _vm.label
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "kpi-item__content" }, [
      _c(
        "p",
        {
          staticClass: "kpi-item__label typographies-paragraph-medium-semibold"
        },
        [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }